//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PatientDuplicateClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPatientDuplicateQueryParameters = {
  showDeleted?: boolean | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type RemovePatientDuplicateQueryParameters = {
  id: number ;
}

export type PatchPatientDuplicateQueryParameters = {
  id: number ;
}

export function getUrl(showDeleted?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/patient-duplicates?";
if (showDeleted === null)
    throw new Error("The parameter 'showDeleted' cannot be null.");
else if (showDeleted !== undefined)
    url_ += "ShowDeleted=" + encodeURIComponent("" + showDeleted) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, unknown, Types.PageableListDtoOfPatientDuplicatePairDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, unknown, Types.PageableListDtoOfPatientDuplicatePairDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetPatientDuplicateQueryParameters): QueryKey;
export function getQueryKey(showDeleted?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { showDeleted, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetPatientDuplicateQueryParameters;

    return trimArrayEnd([
        'PatientDuplicateClient',
        'get',
        showDeleted as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientDuplicateClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as boolean | undefined,       context.queryKey[3] as number | undefined,       context.queryKey[4] as number | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as Types.SortDirection | undefined,       context.queryKey[7] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.PageableListDtoOfPatientDuplicatePairDto, TError = unknown>(dto: GetPatientDuplicateQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all patient duplicates.
 * @param showDeleted (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetQuery<TSelectData = Types.PageableListDtoOfPatientDuplicatePairDto, TError = unknown>(showDeleted?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.PageableListDtoOfPatientDuplicatePairDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let showDeleted: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ showDeleted, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetPatientDuplicateQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [showDeleted, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfPatientDuplicatePairDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(showDeleted, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfPatientDuplicatePairDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all patient duplicates.
 * @param showDeleted (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfPatientDuplicatePairDto | undefined) => Types.PageableListDtoOfPatientDuplicatePairDto, showDeleted?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getQueryKey(showDeleted, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets all patient duplicates.
 * @param showDeleted (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfPatientDuplicatePairDto | undefined) => Types.PageableListDtoOfPatientDuplicatePairDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-duplicates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientDuplicateClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a patient duplicate.
 * @param id The patient duplicate id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemovePatientDuplicateQueryParameters

/**
 * Removes a patient duplicate.
 * @param id The patient duplicate id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemovePatientDuplicateQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-duplicates/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientDuplicateClient',
      'patch',
      id as any,
    ]);
}

/**
 * Restore a patient duplicate pair
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchPatientDuplicatePairDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchPatientDuplicatePairDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchPatientDuplicatePairDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchPatientDuplicateQueryParameters & {
  dto: Types.PatchPatientDuplicatePairDto;
}

/**
 * Restore a patient duplicate pair
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchPatientDuplicateQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}